var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPointBattenHolder01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.9,
    y1: 3.2,
    x2: 7.9,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 7.5,
    x2: 13,
    y2: 7.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 4,
    className: "st0",
    width: 7,
    height: 7.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPointBattenHolder01);
export default __webpack_public_path__ + "static/media/LightPoint-BattenHolder-01.e36d484f3476a72e5c8a7afab7b0d1c2.svg";
export { ForwardRef as ReactComponent };